// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
// @ components
const { MortgagePropertyValue } = require('components/mortgageRequest/mortgageRequestPropertyValue/mortgagePropertyValue/mortgagePropertyValue');

class MortgagePropertyValueView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const breadCrumbData = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgagePropertyValue-breadCrumbText'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        return (
            <div className="mortgage-property-value-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={breadCrumbData}
                                finalTitle={getFinalTitle('mortgagePropertyValue-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-offset-1 col-xs-9">
                                <MortgagePropertyValue
                                    isClientWithoutAccounts={isClientWithoutAccounts}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgagePropertyValueView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired,
}

module.exports.MortgagePropertyValueView = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgagePropertyValueView);
